import styled from "styled-components";

export const CheckboxContainerstyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
